import { ID } from "./id";

export interface INotificationMailSettings_IssueState {
  state: ID;
  interfaces: INotificationMailInterfaces[];
}

export interface INotificationMailInterfaces {
  interfaceName: string,
  typeInterfaceName: string,
  entityName: string,
  properties: string[]
}

export interface INotificationMailSettings_Event {
  event: WfEventValue,
  roles: string[],  // sono i ruoli che ricevono le notifiche di quell'evento
}

export const wfEvent = {
  OLO_ERRORS_WITHOUT_ISSUE: 'olo_errors_without_issue',
} as const;
export type WfEventKey = keyof typeof wfEvent;
export type WfEventValue = (typeof wfEvent)[WfEventKey];
